import type { MessageDescriptor } from '@lingui/core'
import { i18n } from '@lingui/core'
import { pageTitle } from './page-title'

/**
 * Localized page title for a route `head()`, e.g. `Tasks — Planno`.
 *
 * Lives in its own module, importing the Lingui *runtime* but never
 * `i18n.ts`, which loads both compiled `.po` catalogs at module scope.
 *
 * That distinction matters more than it looks: `routeTree.gen.ts` imports
 * every route module eagerly, and the marketing router imports that same
 * route tree. So anything a route file imports at module scope lands in the
 * bundle a marketing visitor downloads. Importing `titleFor` from `i18n.ts`
 * put ~1,700 translated strings on the anonymous marketing homepage — the
 * exact weight the provider-free branch in `RootDocument` exists to avoid.
 *
 * `head()` is a plain function, not a component, so it reads the shared
 * `i18n` singleton rather than `useLingui()`. That is only correct because
 * `getAppRouter()` activates the locale before the router exists.
 *
 * Usage: ``head: () => ({ meta: [{ title: titleFor(msg`Tasks`) }] })``
 */
export const titleFor = (message: MessageDescriptor): string => pageTitle(i18n._(message))
